<template>
  <div>
    <!-- Description -->
    <md-field :class="{
        'md-error': $v.ticketModel.description.$error && $v.ticketModel.description.$invalid,
        'md-valid': !$v.ticketModel.description.$error && !$v.ticketModel.description.$invalid}">
      <label>{{ $t("ticket.create.description") }}</label>
      <md-input v-model.trim="$v.ticketModel.description.$model"></md-input>
      <slide-y-down-transition>
        <md-icon class="error" v-show="$v.ticketModel.description.$error && $v.ticketModel.description.$invalid">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.ticketModel.description.$error && !$v.ticketModel.description.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Select game -->
    <md-field :class="{
        'md-error': $v.ticketModel.gameId.$error && $v.ticketModel.gameId.$invalid,
        'md-valid': !$v.ticketModel.gameId.$error && !$v.ticketModel.gameId.$invalid}">
      <label>{{ $t("ticket.create.game") }}</label>
      <md-select v-model.trim="$v.ticketModel.gameId.$model" name="game" id="game">
        <md-option v-for="game in nextGames" :value="game.id" :key="game.id">{{game.local.name}} vs {{game.visitor.name}} | {{getDate(game.scheduledMatchDate)}} - {{game.season.name}} Fecha : {{game.matchday}}</md-option>
      </md-select>
      <slide-y-down-transition>
        <md-icon class="error" v-show="$v.ticketModel.gameId.$error && $v.ticketModel.gameId.$invalid">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.ticketModel.gameId.$error && !$v.ticketModel.gameId.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Select teams -->
    <md-field :class="{'md-valid': !$v.ticketModel.teamId.$error && !$v.ticketModel.teamId.$invalid}">
      <label>{{ $t("ticket.create.team") }}</label>
      <md-select v-model.trim="$v.ticketModel.teamId.$model" name="team" id="team">
        <md-option v-for="team in listTeams" :value="team.id" :key="team.id">{{team.name}}</md-option>
      </md-select>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.ticketModel.teamId.$error && !$v.ticketModel.teamId.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Quantity -->
    <md-field :class="{
        'md-error': $v.ticketModel.quantity.$error && $v.ticketModel.quantity.$invalid,
        'md-valid': !$v.ticketModel.quantity.$error && !$v.ticketModel.quantity.$invalid}">
      <label>{{ $t("ticket.create.quantity") }}</label>
      <md-input type="number" v-model.trim="$v.ticketModel.quantity.$model"></md-input>
      <slide-y-down-transition>
        <md-icon class="error" v-show="$v.ticketModel.quantity.$error && $v.ticketModel.quantity.$invalid">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.ticketModel.quantity.$error && !$v.ticketModel.quantity.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <md-button @click="createTickets" :disabled="submittedTickets" class="md-info" :class="{ disabled: submittedTickets }">
      {{ $t("ticket.create.create") }}
    </md-button>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import { required } from "vuelidate/lib/validators";
import { mapState } from 'vuex'; 

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      submittedTickets: false,
      listGames: [],
      listTeams: [],
      ticketModel: {
        description: "",
        gameId: null,
        teamId: 0,
        quantity: null
      }
    }
  },
  computed: {
    ...mapState({
      nextGames: state => state.GameModule.nextGames
    })
  },
  async mounted() {
    await this.$store.dispatch("gameGetNext")
  },
  methods: {
    async createTickets() {
      this.$v.ticketModel.$touch();
      if (!this.$v.ticketModel.$invalid) {
        this.submittedTickets = true;
        this.ticketModel.quantity = Number(this.ticketModel.quantity)
        await this.$store.dispatch('generateTicketLot', this.ticketModel)
        this.$notify({
          message: this.$t(`notifications.ticket.create`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.submittedTickets = false;
        this.$router.push("/list/ticketera");
      }
    },
    getDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    }
  },
  watch: {
    'ticketModel.gameId': function() {
      const gameSelect = this.nextGames.find(game => game.id == this.ticketModel.gameId)
      this.listTeams = [
        gameSelect.local,
        gameSelect.visitor
      ]
    }
  },
  validations: {
    ticketModel: {
      description: {
        required
      },
      gameId: {
        required
      },
      teamId: {},
      quantity: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
.md-menu-content {
  max-width: 50%;
}
</style>